import React, { useEffect, useState } from 'react';
import Sidebar from './components/SideBar'
import Alert from './components/Alert'
import { HashRouter, Route, Routes } from 'react-router-dom';
import {
  Home,
  Admins,
  AdminLogin,
  CarTows,
  Users,
  Trips,
  Vouchers,
  VoucherVersions,
  Subscriptions,
  Profits,
  Coupons,
  UserCoupons,
  Reports,
  Complaints,
  Notifications,
  Settings,
  Activity,
  Requests
} from './pages'
import UserState from './components/UserState';
import { useSelector } from 'react-redux';


function App() {
  const user = useSelector(state => state.userController.user)
  const [theme,setTheme] = useState('light')

  const toggleTheme = () => {
    setTheme(prev => {
      if(prev === 'light'){
        window.localStorage.setItem('theme','dark')
        return 'dark'
      }else {
        window.localStorage.setItem('theme','light')
        return 'light'
      }
    })
  }

  useEffect(()=>{
    const storageTheme = window.localStorage.getItem('theme')
    if(storageTheme){
      setTheme(storageTheme)
    }
  },[])
  return (
    <main className={`App ${theme}`}>
      <HashRouter >
        <Alert />
        {user && <Sidebar theme={theme} toggleTheme={toggleTheme} />}
        <UserState />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/car-tows" element={<CarTows />} />
          <Route path="/users" element={<Users />} />
          <Route path="/trips" element={<Trips />} />
          <Route path="/vouchers" element={<Vouchers />} />
          <Route path="/vouchers/:voucherTypeId/versions" element={<VoucherVersions />} />
          <Route path="/subscriptions" element={<Subscriptions />} />
          <Route path="/profits" element={<Profits />} />
          <Route path="/coupons" element={<Coupons />} />
          <Route path="/user-coupons" element={<UserCoupons />} />
          <Route path="/reports" element={<Reports />} />
          <Route path="/complaints" element={<Complaints />} />
          <Route path="/notifications" element={<Notifications />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/activity" element={<Activity />} />
          <Route path="/requests" element={<Requests />} />
          <Route path="/admins" element={<Admins />} />
          <Route path="/login" element={<AdminLogin />}/>
        </Routes>
      </HashRouter>
    </main>
  );
}

export default App;
